import moment from 'moment-timezone';

import {
  ORDERS_REFUNDED_SET_SORTING,
  ORDERS_REFUNDED_SET_FILTER_TIME,
  ORDERS_REFUNDED_SET_FILTER_SEARCH,
  ORDERS_REFUNDED_RESET_FILTER,
  ORDERS_REFUNDED_SET_MESSAGE_FILTER,

  ORDERS_REFUNDED_REQUEST,
  ORDERS_REFUNDED_RECEIVE,
} from './actions';

const filter = (state, action) => {
  switch (action.type) {
    case ORDERS_REFUNDED_SET_FILTER_TIME:
      return Object.assign({}, state, {
        time: action.value,
      });
    case ORDERS_REFUNDED_SET_FILTER_SEARCH:
      return Object.assign({}, state, {
        search: action.value,
      });
    case ORDERS_REFUNDED_SET_MESSAGE_FILTER:
      return Object.assign({}, state, {
        new_messages: action.value,
      });
    default:
      return state;
  }
};

const sorting = (state = {}, action) => {
  switch (action.type) {
    case ORDERS_REFUNDED_SET_SORTING:
      return Object.assign({}, state, {
        field: action.value,
        isAsc: state.field === action.value ? !state.isAsc : true,
      });
    default:
      return state;
  }
};

const ordersRefunded = (state = {
  sorting: { field: 'writer_deadline', isAsc: true },
  filter: { time: 'all', search: '', new_messages: false },
  total: null,
  limit: 25,
  page: 1,
  numbers: [],
  isFetching: false,
  didInvalidate: true,
  unreadOrderMessages: null,
}, action) => {
  switch (action.type) {
    case ORDERS_REFUNDED_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false,
      });
    case ORDERS_REFUNDED_RECEIVE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        updatedAt: moment(),
        numbers: action.page === 1 ? action.numbers : [...state.numbers, ...action.numbers],
        total: action.total,
        limit: action.limit,
        page: action.page,
        unreadOrderMessages: action.unreadOrderMessages,
      });
    case ORDERS_REFUNDED_SET_SORTING:
      return Object.assign({}, state, {
        sorting: sorting(state.sorting, action),
      });
    case ORDERS_REFUNDED_SET_FILTER_TIME:
    case ORDERS_REFUNDED_SET_FILTER_SEARCH:
    case ORDERS_REFUNDED_SET_MESSAGE_FILTER:
      return Object.assign({}, state, {
        filter: filter(state.filter, action),
      });
    case ORDERS_REFUNDED_RESET_FILTER:
      return Object.assign({}, state, {
        filter: { time: 'all', search: '', new_messages: false },
      });
    default:
      return state;
  }
};

export default ordersRefunded;
